import { parseEnumFilter, parseNumberFilter, toFilterText, toPeriodSearch } from '@/utils/filters';
import {
  DEFAULT_FEEDBACK_COMPLETE_FILTER,
  FEEDBACK_COMPLETE_FILTER,
  FEEDBACK_FILTER_KEYS,
  FEEDBACK_READ_FILTER,
} from '../constants/feedback.constants';
import type { FeedbackListParams, FeedbackSearch } from '../types/feedback.types';

type FilterValues = Record<string, string>;

type FeedbackFilterSearch = Omit<FeedbackSearch, 'search'>;

export function toFeedbackFilterValues(search: FeedbackFilterSearch): FilterValues {
  return {
    dateFrom: toFilterText(search.dateFrom),
    dateTo: toFilterText(search.dateTo),
    [FEEDBACK_FILTER_KEYS.typeId]: toFilterText(search.typeId),
    [FEEDBACK_FILTER_KEYS.reportingToId]: toFilterText(search.reportingToId),
    [FEEDBACK_FILTER_KEYS.userId]: toFilterText(search.userId),
    [FEEDBACK_FILTER_KEYS.completeStatus]:
      search.completeStatus ?? DEFAULT_FEEDBACK_COMPLETE_FILTER,
    [FEEDBACK_FILTER_KEYS.readStatus]: toFilterText(search.readStatus),
  };
}

export function toFeedbackFilterSearch(values: FilterValues): FeedbackFilterSearch {
  return {
    ...toPeriodSearch(values),
    typeId: parseNumberFilter(values[FEEDBACK_FILTER_KEYS.typeId]),
    reportingToId: parseNumberFilter(values[FEEDBACK_FILTER_KEYS.reportingToId]),
    userId: parseNumberFilter(values[FEEDBACK_FILTER_KEYS.userId]),
    completeStatus: parseEnumFilter(
      values[FEEDBACK_FILTER_KEYS.completeStatus],
      FEEDBACK_COMPLETE_FILTER,
    ),
    readStatus: parseEnumFilter(values[FEEDBACK_FILTER_KEYS.readStatus], FEEDBACK_READ_FILTER),
  };
}

export function toFeedbackListParams(search: FeedbackSearch): FeedbackListParams {
  const completeStatus = search.completeStatus ?? DEFAULT_FEEDBACK_COMPLETE_FILTER;
  return {
    search: search.search,
    startDate: search.dateFrom,
    endDate: search.dateTo,
    typeId: search.typeId,
    reportingToId: search.reportingToId,
    userId: search.userId,
    completeStatus: completeStatus === 'all' ? undefined : completeStatus,
    readStatus: search.readStatus,
  };
}
